module.exports = __webpack_public_path__ + "img/6.5dc0c873.png";